import UserReducer from "./userReducer";
import AuthReducer from "./AuthReducer";
import ProfessionalReducer from "./professionalreducer";
import { combineReducers } from "redux";

const AllReducers = combineReducers({
  user: UserReducer,
  auth: AuthReducer,
  professional:ProfessionalReducer
});

export default AllReducers;
